import React from 'react';
import { iconSizer } from "../../../../../icons2022/iconSizer";
import { ArchiveIcon24Regular } from "../../../../../icons2022/FileTypeArchiveIcon/ArchiveIcon24Regular";
import { ArchiveIcon32Regular } from "../../../../../icons2022/FileTypeArchiveIcon/ArchiveIcon32Regular";
import { ArchiveIcon64Regular } from "../../../../../icons2022/FileTypeArchiveIcon/ArchiveIcon64Regular";
export var ArchiveIcon = iconSizer({
  small: function small() {
    return /*#__PURE__*/React.createElement(ArchiveIcon24Regular, null);
  },
  medium: function medium() {
    return /*#__PURE__*/React.createElement(ArchiveIcon32Regular, null);
  },
  large: function large() {
    return /*#__PURE__*/React.createElement(ArchiveIcon64Regular, null);
  }
}, 'ArchiveIcon');